import { useFetchUser } from "./useFetchUser";
import { useMerchant } from "./useMerchant";

export function usePermissions() {
  const { user } = useFetchUser();
  const { merchant } = useMerchant();
  const membership = user?.merchants?.[merchant?.id ?? ""];

  return {
    isMerchantAdmin:
      (user?.roles?.includes("admin") ||
        membership?.roles?.includes("admin")) ??
      false,
    isEditor:
      (user?.roles?.includes("editor") ||
        membership?.roles?.includes("editor")) ??
      false,
    isPayoutPreparer:
      (user?.roles?.includes("payout-preparer") ||
        membership?.roles?.includes("payout-preparer")) ??
      false,
    isPayoutApprover:
      (user?.roles?.includes("payout-approver") ||
        membership?.roles?.includes("payout-approver")) ??
      false,
    isDeveloper:
      (user?.roles?.includes("developer") ||
        membership?.roles?.includes("developer")) ??
      false,

    isAdmin: user?.admin ?? false,
  };
}
